module.exports = __webpack_public_path__ + "img/renwu3.6a1acb54.png";